import { useMemo } from 'react';
import { getFeatureFlags, isFeatureEnabled } from './feature-flags';
import type { FeatureFlag } from './flags';

/**
 * Is `flag` enabled? Today the source is static, so this is a thin wrapper;
 * it exists so a future gateway-served source can make it reactive without
 * changing any consumer.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return isFeatureEnabled(flag);
}

/** The whole flag map, referentially stable across renders. */
export function useFeatureFlags(): Readonly<Record<FeatureFlag, boolean>> {
  return useMemo(() => getFeatureFlags(), []);
}
